import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconVRBORectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <g clipPath="url(#clip0_19654_1036)">
      <rect width="28" height="28" rx="7" fill="#34E0A1" />
      <path
        d="M22.2445 27.9836H5.75546C2.58622 27.9836 0 25.4018 0 22.2231V5.76222C0 2.5984 2.58622 0.0166016 5.75546 0.0166016H22.2445C25.4287 0.0166016 27.9999 2.5984 27.9999 5.76222V22.2231C28.0149 25.4018 25.4287 27.9836 22.2445 27.9836Z"
        fill="#0E214B"
      />
      <path
        d="M17.5096 11.6835C17.5068 11.6943 17.5111 11.706 17.5203 11.7122C17.535 11.7219 17.555 11.7142 17.5601 11.6974C18.6123 8.21124 19.0171 6.47694 18.3465 5.39419C18.1972 5.15301 17.9129 5.0459 17.6292 5.0459H16.5955C16.5858 5.0459 16.578 5.05375 16.578 5.06342C16.578 5.07082 16.5828 5.07747 16.5897 5.07999C18.2369 5.67976 18.6223 7.34972 17.5096 11.6835Z"
        fill="#8EC089"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6366 5.06091C22.3501 5.06091 22.0652 5.13145 21.8313 5.29688C20.4738 6.25726 19.5324 7.98762 17.7248 11.8145C17.719 11.8268 17.7229 11.8419 17.7342 11.8494C17.7477 11.8584 17.7662 11.8534 17.7739 11.8391C20.034 7.64147 21.3348 5.95925 24.2498 5.09443C24.2571 5.09228 24.2622 5.08557 24.2622 5.078C24.2622 5.06856 24.2546 5.06091 24.2452 5.06091H22.6366Z"
        fill="#2474DE"
      />
      <path
        d="M17.6023 11.7563C17.598 11.768 17.6022 11.7815 17.6126 11.7884C17.6267 11.7978 17.6461 11.7914 17.6527 11.7758C19.5074 7.42074 19.9869 6.24119 20.7602 5.09658C20.7627 5.09279 20.7641 5.08832 20.7641 5.08376C20.7641 5.07114 20.7539 5.06091 20.7412 5.06091H19.299C19.2743 5.06091 19.2542 5.08096 19.2542 5.10568C19.4183 6.84819 18.8082 8.45692 17.6023 11.7563Z"
        fill="#E85F24"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.41833 5.2656C5.25538 5.12427 5.04101 5.06091 4.8253 5.06091H3.82962C3.81983 5.06091 3.81189 5.06885 3.81189 5.07864C3.81189 5.08595 3.81647 5.09254 3.82328 5.09522C4.91827 5.52565 5.51039 6.31753 5.97612 8.02927C6.08632 8.43427 6.172 8.84578 6.26103 9.25595C6.81827 11.8232 8.9673 21.6545 9.35705 23.4374C9.3937 23.605 9.54018 23.7155 9.7118 23.7155C9.94486 23.7155 10.1183 23.5001 10.0685 23.2724L6.84659 8.52321C6.37279 6.35743 5.86779 5.65542 5.41833 5.2656Z"
        fill="#76C5F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9693 21.6856C12.0396 22.0094 12.4794 22.0621 12.6242 21.7641C12.6583 21.6941 12.6679 21.6147 12.6517 21.5385L9.89621 8.64257C9.54139 7.18279 9.4959 6.30202 9.5762 5.68931C9.61649 5.38187 9.39647 5.07581 9.0864 5.07581C8.83882 5.07581 8.63494 5.27416 8.64007 5.52169C8.6537 6.17993 8.74195 6.88702 9.05905 8.29932L11.9693 21.6856Z"
        fill="#2474DE"
      />
      <path
        d="M7.73642 5.63974C7.68486 5.30855 7.40359 5.06091 7.06841 5.06091H6.41943C6.40736 5.06091 6.39758 5.07069 6.39758 5.08276C6.39758 5.08793 6.39944 5.09295 6.40276 5.0969C6.96666 5.76734 7.13142 6.58863 7.56362 8.3889L10.8495 23.4282C10.8861 23.5959 11.0347 23.7155 11.2064 23.7155C11.4394 23.7155 11.6129 23.5003 11.5634 23.2726L8.31109 8.31428C7.95698 6.87817 7.82403 6.20255 7.73642 5.63974Z"
        fill="#318EEE"
      />
      <path
        d="M12.9562 19.5934C13.0266 19.9237 13.4743 19.9796 13.6237 19.6768C13.659 19.6053 13.6693 19.5241 13.653 19.4461L11.4358 8.86621C11.0186 6.79863 11.1954 5.72438 11.8775 5.09671C11.8818 5.09276 11.8843 5.0872 11.8843 5.08137C11.8843 5.06994 11.875 5.06067 11.8636 5.06067H11.1498C10.8677 5.06067 10.6021 5.21952 10.514 5.48755C10.2939 6.15794 10.2854 6.98373 10.6285 8.6722L12.9562 19.5934Z"
        fill="#E85F24"
      />
      <path
        d="M12.2286 8.94104C11.7262 6.53362 12.4057 5.6116 12.9372 5.23677C13.1104 5.1146 13.3252 5.07581 13.5371 5.07581H14.9629C14.9719 5.07581 14.9793 5.08313 14.9793 5.09217C14.9793 5.1 14.9735 5.10678 14.9658 5.10829C13.0632 5.48366 12.5137 6.52908 12.9761 8.94104L14.6571 17.3908C14.6722 17.4663 14.662 17.5447 14.6283 17.614C14.4807 17.9175 14.0322 17.8603 13.9653 17.5296L12.2286 8.94104Z"
        fill="#8EC089"
      />
    </g>
    <defs>
      <clipPath id="clip0_19654_1036">
        <rect width="28" height="28" rx="7" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const IconVRBORectangle = forwardRef(_IconVRBORectangle)
